import { ref } from 'vue'

const isOpen = ref(false)
const message = ref('')
const confirmTitle = ref('Potvrzení')
const confirmLabel = ref('Potvrdit')
// Destructive action (zamítnout, smazat) — the primary button turns red.
const confirmDanger = ref(false)
// Optional second (secondary) action — confirmChoice() resolves 'alt' for it.
const altLabel = ref('')
let _resolve: ((v: boolean) => void) | null = null
let _resolveChoice: ((v: 'confirm' | 'alt' | null) => void) | null = null

// In-app replacement for window.confirm — the native dialog says
// „app.qcms.cz says" and looks like an error. Mounted once per layout
// (AppConfirmDialog in default + full-height).
export function useConfirmDialog() {
  function confirmDialog(
    msg: string,
    title?: string,
    opts?: { confirmLabel?: string; danger?: boolean },
  ): Promise<boolean> {
    message.value = msg
    confirmTitle.value = title ?? 'Potvrzení'
    confirmLabel.value = opts?.confirmLabel ?? 'Potvrdit'
    confirmDanger.value = !!opts?.danger
    altLabel.value = ''
    isOpen.value = true
    return new Promise((resolve) => {
      _resolve = resolve
    })
  }

  /** Two actions + Zrušit: resolves 'confirm' (primary), 'alt' or null. */
  function confirmChoice(
    msg: string,
    title: string,
    opts: { confirmLabel: string; altLabel: string },
  ): Promise<'confirm' | 'alt' | null> {
    message.value = msg
    confirmTitle.value = title
    confirmLabel.value = opts.confirmLabel
    confirmDanger.value = false
    altLabel.value = opts.altLabel
    isOpen.value = true
    return new Promise((resolve) => {
      _resolveChoice = resolve
    })
  }

  function _settle(v: 'confirm' | 'alt' | null) {
    isOpen.value = false
    _resolve?.(v === 'confirm')
    _resolveChoice?.(v)
    _resolve = null
    _resolveChoice = null
  }
  const _accept = () => _settle('confirm')
  const _reject = () => _settle(null)
  const _alt = () => _settle('alt')

  return {
    confirmDialog,
    confirmChoice,
    _accept,
    _reject,
    _alt,
    isOpen,
    message,
    confirmTitle,
    confirmLabel,
    confirmDanger,
    altLabel,
  }
}
